import { render, staticRenderFns } from "./SectionHeaderArtworks.vue?vue&type=template&id=07d11672"
import script from "./SectionHeaderArtworks.vue?vue&type=script&lang=js"
export * from "./SectionHeaderArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports